import CityComponent from './city.component';

export const cityModule = {
	name: 'cityComponent',
};

export default angular
	.module(cityModule.name, [])
	.component('city', new CityComponent()).name;
